import { render } from "./ed-organism-pop-up.vue?vue&type=template&id=ed4b6d9c"
import script from "./ed-organism-pop-up.vue?vue&type=script&lang=js"
export * from "./ed-organism-pop-up.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__